export const Mark = ({ className = "h-6 w-6", white = false, alt = "Ninja Run Club mark" }) => (
  <img
    src={white ? "/brand/nr-mark-white.png" : "/brand/nr-mark.png"}
    alt={alt}
    aria-hidden={alt === "" ? "true" : undefined}
    width="48"
    height="48"
    loading="lazy"
    className={`object-contain ${className}`}
    draggable="false"
  />
);

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display leading-none ${className}`}>
    NINJA&nbsp;RUN&nbsp;CLUB
  </span>
);

export const Monogram = ({ className = "" }) => (
  <span className={`font-display leading-none ${className}`}>NR</span>
);
